import { apiGet } from "../../utils/axios.js";
import apiEndpoints from "../../apiEndpoints.js";

export function getCustomersList(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.customer.customerList()+url)
            dispatch({
                type: 'REPORTS_CUSTOMER_LIST_SUCCESS',
                payload: response.data
            })
        } catch (error) {
            console.log(error)
        }
    }
}

export function getOrganizationList (url="") {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.organizations.organizationList()+url);
            dispatch({
                type: 'REPORTS_ORGANIZATION_LIST_SUCCESS',
                payload: response.data
            })
        } catch (error) {
            console.log(error)
        }
    };
}

export function getDomainList(url="") {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.domains.domainList()+url)
            dispatch({
                type: 'REPORTS_DOMAIN_LIST_SUCCESS',
                payload: response.data
            })
        } catch (error) {
            console.log(error)
        }
    }
}

export function getScanHistory(url) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scan.scanHistory()+url)
            dispatch({
                type: 'REPORTS_SCAN_HISTORY_SUCCESS',
                payload: response.data
            })
        } catch(error) {
            console.log(error)
        }
    }
}

export function getDownloadExcelDocument(url, reportName) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.reports.downloadExcelReport() + url, true, 'excel');
            if (response?.status === 200) {
                const blob = response.data;
                const fileName = `${reportName}`;

                const url = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.href = url;
                a.download = fileName; // Set the desired file name
                document.body.appendChild(a);
                a.click();
                a.remove();
                window.URL.revokeObjectURL(url);

                dispatch({
                    type: 'DOWNLOAD_EXCEL_REPORT_SUCCESS',
                    payload: { fileName, status: "success" }, // Only storing metadata
                });
            } else {
                dispatch({
                    type: 'DOWNLOAD_EXCEL_REPORT_SUCCESS',
                    payload: { status: "failed", message: response.detail },
                });
            }
        } catch (error) {
            console.log(error);
        }
    };
}

export function resetDownloadReportResponse() {
    return (dispatch) => {
        dispatch({
            type: 'RESET_DOWNLOAD_DATA'
        })
    }
}

export function getDownloadPdfDocument(url, domainName, selectedModulePdfOption) {
    return async (dispatch) => {
        try {
            const reportConfig = {
                fullReport: {
                    endpoint: apiEndpoints.scanInfo.reports.downloadPdfFullReport(),
                    reportType: "full_report",
                },
                executiveSummary: {
                    endpoint: apiEndpoints.scanInfo.reports.downloadPdfExecutiveSummaryReport(),
                    reportType: "executive_summary",
                },
                oneTimeScanFullReport: {
                    endpoint: apiEndpoints.scanInfo.reports.downloadOneTimeScanFullReport(),
                    reportType: "one_time_scan_full_report",
                },
                oneTimeScanExecutiveSummary: {
                    endpoint: apiEndpoints.scanInfo.reports.downloadOneTimeScanExecutiveSummaryReport(),
                    reportType: "one_time_scan_executive_summary",
                },
            };

            const { endpoint, reportType } = reportConfig[selectedModulePdfOption] || reportConfig.oneTimeScanExecutiveSummary;
            
            const response = await apiGet(endpoint  + url, true, 'pdf');
            if (response?.status === 200) {
                const blob = response.data;
                const fileName = `${domainName}_${reportType}.pdf`;
                const url = window.URL.createObjectURL(blob);

                // Create download link
                const a = document.createElement("a");
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);

                // Store only metadata in Redux (not the Blob)
                dispatch({
                    type: "DOWNLOAD_PDF_REPORT_SUCCESS",
                    payload: { fileName, status: "success" }, // Only storing metadata
                });
            } else {
                dispatch({
                    type: "DOWNLOAD_PDF_REPORT_SUCCESS",
                    payload: { status: "failed", message: response.detail },
                });
            }
        } catch (error) {
            console.log(error);
        }
    };
}

export function getDownloadthirdPartyPdfDocument(url, domainName) {
    return async (dispatch) => {
        try {
            const response = await apiGet(apiEndpoints.scanInfo.thirdPartyRisk.reports.pdfFullReport() + url, true, 'pdf');
            if (response?.status === 200) {
                // Handle file download here (NOT in Redux)
                const blob = response.data;
                const fileName = `${domainName}_full_report.pdf`;
                const url = window.URL.createObjectURL(blob);

                // Create download link
                const a = document.createElement("a");
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);

                // Store only metadata in Redux (not the Blob)
                dispatch({
                    type: "DOWNLOAD_THIRD_PARTY_PDF_REPORT_SUCCESS",
                    payload: { fileName, status: "success" }, // Only storing metadata
                });
            } else {
                dispatch({
                    type: "DOWNLOAD_THIRD_PARTY_PDF_REPORT_SUCCESS",
                    payload: { status: "failed", message: response.detail },
                });
            }
        } catch (error) {
            console.log(error);
        }
    };
}